import React, { useEffect, useState } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  // title?: string
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    let closeTimer: number | undefined;
    let rafId: number | undefined;

    if (isOpen) {
      setShouldRender(true);
      rafId = window.requestAnimationFrame(() => setAnimating(true));
    } else {
      setAnimating(false);
      closeTimer = window.setTimeout(() => {
        setShouldRender(false);
      }, 200);
    }

    return () => {
      if (rafId !== undefined) window.cancelAnimationFrame(rafId);
      if (closeTimer !== undefined) window.clearTimeout(closeTimer);
    };
  }, [isOpen]);

  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen, onClose]);

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 z-[99999] flex items-center justify-center transition-all duration-200 ${
        animating ? "bg-black/40 backdrop-blur-[2px]" : "bg-transparent"
      }`}
    >
      {/* Backdrop click to close */}
      <div
        className="absolute inset-0"
        onClick={onClose}
        role="button"
        aria-label="Close modal"
      />

      {/* Modal content */}
      <div
        className={`relative w-[92%] rounded-2xl bg-white transition-all duration-200 ${
          animating
            ? "translate-y-0 scale-100 opacity-100"
            : "translate-y-2 scale-95 opacity-0"
        }`}
      >
        {/* {title && (
          <h2 className="mb-4 text-lg font-semibold text-gray-800">{title}</h2>
        )} */}
        {children}
      </div>
    </div>
  );
};

export default Modal;
